import { render, staticRenderFns } from "./projectAvatar.vue?vue&type=template&id=564313ae&scoped=true&"
import script from "./projectAvatar.vue?vue&type=script&lang=js&"
export * from "./projectAvatar.vue?vue&type=script&lang=js&"
import style0 from "./projectAvatar.vue?vue&type=style&index=0&id=564313ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564313ae",
  null
  
)

export default component.exports